<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Tư vấn khách hàng</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Chọn trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="4">
        </el-col>
        <el-col :span="2">
        </el-col>
        <el-col :span="6">
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            clearable
            class="input-seach"
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="table.pagination.per_page"
          :pager-count="table.pagination.count"
          :current-page="table.pagination.current_page"
          :total="table.pagination.total"
          @current-change="changeCurrentPage">
        </el-pagination>
        <div>
          Hiển thị tới Tư vấn khách hàng <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Tư vấn khách hàng
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            label="Nội dung">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info" v-if="scope.row.content">
                  <span>Họ và tên: {{ scope.row.content.name }}</span>
                  <span>Ngày sinh: {{ scope.row.content.birthday }}</span>
                  <span>Số điện thoại: {{ scope.row.content.phone }}</span>
                  <span>Email: {{ scope.row.content.email }}</span>
                  <span>Trường tốt nghiệp gần nhất: {{ scope.row.content.school }}</span>
                  <span>Xét tuyển theo: {{ scope.row.content.admission }}</span>
                  <span>Hệ đào tạo: {{ scope.row.content.level }}</span>
                  <span>Chuyên ngành: {{ scope.row.content.facult }}</span>
                  <span>Hệ cam kết đào tạo: {{ scope.row.content.commit }}</span>
                  <span>Địa chỉ liên hệ: {{ scope.row.content.address }}</span>
                  <span>Địa điểm nộp hồ sơ và học tập: {{ scope.row.content.key_address_text }}</span>
                </div>
                <div class="courses-info" v-if="scope.row.userContent">
                  <span>Họ và tên: {{ scope.row.userContent.name }}</span>
                  <span>Ngày sinh: {{ scope.row.userContent.birthday }}</span>
                  <span>Số điện thoại: {{ scope.row.userContent.phone }}</span>
                  <span>Email: {{ scope.row.userContent.email }}</span>
                  <span>Hệ đào tạo: {{ scope.row.userContent.level_name }}</span>
                  <span>Địa chỉ liên hệ: {{ scope.row.userContent.city_name }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền / Nguồn">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
              <p style="color: green">{{ scope.row.type_txt }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Nhân viên xử lý"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.user_id_care_name }}</span>
                <span>{{ scope.row.user_id_care_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Hành động"
            header-align="center"
            width="180">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="module-action">
                  <el-tooltip effect="dark" content="Tự động tạo tài khoản và đăng kí lớp" placement="top" v-if="scope.row.user_id_care == accountInfo.id && scope.row.class_user_id == 0 && scope.row.type == 1">
                    <span @click="addClassModel(scope.row)">
                      <i class="fas fa-plus-circle"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Thêm ghi chú" placement="top" v-if="scope.row.user_id_care == accountInfo.id">
                    <span @click="updateModel(scope.row)">
                      <i class="far fa-edit icon-update"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Lịch sử ghi chú" placement="top">
                    <span @click="showLog(scope.row)">
                      <i class="fas fa-history"></i>
                    </span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>

    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử ghi chú'"
      :visible.sync="classUser.dialogVisibleLog"
      width="45%">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Lịch sử ghi chú" name="first">
          <div class="log-class-user" v-if="classUser.modelData.notes">
            <div
              class="item"
              :key="index_1"
              v-for="(item, index_1) in classUser.modelData.notes">
              <strong>{{ item.text }}</strong>
              <div>
                <span class="time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classUser.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  inject: ['$validator'],
  name: 'CategoryBlog',
  metaInfo () {
    return {
      title: 'Tư vấn khách hàng'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      activeName: 'first',
      loading: false,
      searching: false,
      canSubmit: true,
      filter: {
        q: '',
        user_id_care_confirm: 1,
        status: '',
        page: 1,
        limit: 12,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 0, value: 'Đang hỗ trợ'},
          {key: 1, value: 'Hoàn thành'},
          {key: 2, value: 'Hủy hỗ trợ'}
        ]
      },
      table: {
        database: [],
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      classUser: {
        dialogVisible: false,
        dialogVisibleLog: false,
        dialogVisibleOpen: false,
        modelData: {},
        modelPush: {
          money: 1000000
        },
        courses_default: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'help-cares-index', text: 'Tư vấn khách hàng' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('help-cares', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'help-cares-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'help-cares-show', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('help-cares/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('help-cares/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },

    // Show log:
    showLog (model) {
      this.classUser.modelData = model
      this.classUser.dialogVisibleLog = true
    },

    updateModel (model) {
      this.$prompt('Nhập nội dung ghi chú mới', 'Khách hàng ' + model.email, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(({ value }) => {
        this.addChaperToServer(value, model)
      }).catch(() => {

      })
    },

    addChaperToServer (value, model) {
      if (value) {
        let data = {
          note: value
        }
        axios.put('help-cares/' + model.id, data).then(response => {
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Thêm ghi chú thành công thành công',
                type: 'success'
              })
              this.fetchDatabaseModel()
              break
            case 404:
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: 'Không tìm thấy tài nguyên',
                type: 'warning'
              })
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
    },

    addClassModel (model) {
      this.$confirm('Xác nhận tạo tài khoản và đăng kí lớp tương ứng theo nguyện vọng của học viên: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.addClassModelAction(model)
      }).catch(() => {

      })
    },
    addClassModelAction (model) {
      axios.post('help-cares/add-class/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Tạo tài khoản và đăng kí lớp thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}

.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}

.courses-info-2 {
  display: flex;
  flex-direction: row;
}

.log-class-user .item {
  margin-bottom: 10px;
}
.log-class-user .time {
  color: #7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/components/help-cares/Index.vue